export default "__VITE_ASSET__BjkNtPqJ__"